import { useAuthContext } from "@mavenmm/teamwork-auth";
import { useCurrentUser } from "./useCurrentUser";
import { canUseModelComparison } from "../lib/assistantAccess";

/**
 * Whether the signed-in person sees the multi-model comparison surface.
 *
 * Reads currentUser first so admin impersonation behaves like every other feature
 * here — viewing as someone else shows what they would see.
 */
export function useAssistantAccess() {
  const { user } = useAuthContext();
  const { user: currentUser, isLoading } = useCurrentUser();
  const email = currentUser?.email_address ?? user?.email;

  return {
    canCompareModels: canUseModelComparison(email),
    /** True until we know who this is — callers should not flash the gated UI. */
    isLoading,
  };
}
